import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileText, Image as ImageIcon, Trash2, Search, ChevronLeft, ChevronRight } from "lucide-react";
import { api, resolveMedia } from "../../lib/api";
import { inputCls, errMsg } from "./shared";

export default function MediaManager() {
  const [data, setData] = useState({ items: [], total: 0, page: 1, pages: 1 });
  const [search, setSearch] = useState("");
  const [kind, setKind] = useState("");
  const [page, setPage] = useState(1);

  const load = (p = page, s = search, k = kind) => {
    const params = new URLSearchParams({ page: p, limit: 24 });
    if (s) params.set("search", s);
    if (k) params.set("kind", k);
    api.get(`/admin/files?${params}`).then((r) => setData(r.data)).catch(() => {});
  };
  useEffect(() => { load(page, search, kind); }, [page, kind]);

  const doSearch = (e) => {
    e.preventDefault();
    setPage(1);
    load(1, search, kind);
  };

  const remove = async (id) => {
    if (!window.confirm("क्या आप यह फाइल हटाना चाहते हैं?")) return;
    try {
      await api.delete(`/admin/files/${id}`);
      toast.success("फाइल हटाई गई");
      load();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <div>
      <form onSubmit={doSearch} className="flex flex-wrap gap-3 mb-6">
        <div className="relative flex-1 min-w-[220px]">
          <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-ngo-ink/40" />
          <input data-testid="media-search" placeholder="फाइल नाम से खोजें..." className={`${inputCls} pl-10`} value={search} onChange={(e) => setSearch(e.target.value)} />
        </div>
        <select data-testid="media-kind-filter" className={`${inputCls} w-auto`} value={kind} onChange={(e) => { setKind(e.target.value); setPage(1); }}>
          <option value="">सभी फाइलें</option>
          <option value="image">इमेज</option>
          <option value="document">PDF दस्तावेज़</option>
        </select>
      </form>

      <div data-testid="media-grid" className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-4">
        {data.items.map((f) => (
          <div key={f.id} className="group relative bg-white rounded-xl border border-ngo-deep/10 overflow-hidden">
            {f.kind === "document" || f.content_type === "application/pdf" ? (
              <a href={resolveMedia(f.url)} target="_blank" rel="noopener noreferrer" className="h-28 flex flex-col items-center justify-center gap-1.5 bg-ngo-mint/60 text-ngo-deep">
                <FileText size={28} />
                <span className="text-[10px] font-bold">PDF</span>
              </a>
            ) : (
              <img src={resolveMedia(f.url)} alt={f.original_filename} loading="lazy" className="w-full h-28 object-cover" />
            )}
            <p className="px-2.5 py-2 text-[11px] text-ngo-ink/60 truncate" title={f.original_filename}>{f.original_filename}</p>
            <button
              data-testid={`media-delete-${f.id}`}
              onClick={() => remove(f.id)}
              aria-label="हटाएं"
              className="absolute top-2 right-2 w-7 h-7 rounded-full bg-red-600 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200"
            >
              <Trash2 size={12} />
            </button>
          </div>
        ))}
      </div>
      {data.items.length === 0 && <p data-testid="media-empty" className="text-center text-ngo-ink/50 py-14">कोई फाइल नहीं मिली।</p>}

      <div className="mt-8 flex items-center justify-center gap-4">
        <button data-testid="media-prev" disabled={page <= 1} onClick={() => setPage(page - 1)} className="w-10 h-10 rounded-full bg-white border border-ngo-deep/20 text-ngo-deep flex items-center justify-center disabled:opacity-40" aria-label="पिछला पेज">
          <ChevronLeft size={17} />
        </button>
        <span className="text-sm text-ngo-ink/60">पेज {data.page} / {data.pages} • कुल {data.total} फाइलें</span>
        <button data-testid="media-next" disabled={page >= data.pages} onClick={() => setPage(page + 1)} className="w-10 h-10 rounded-full bg-white border border-ngo-deep/20 text-ngo-deep flex items-center justify-center disabled:opacity-40" aria-label="अगला पेज">
          <ChevronRight size={17} />
        </button>
      </div>
    </div>
  );
}
